export const IntentWorkflowActions = {
  CLEAR_CONVERSATION: 'workflows/clearConversation',
  GET_AUTOFLOW_STREAM: 'workflows/getAutoflowStream',
  GET_KNOWLEDGE_RETRIEVAL_STREAM: 'workflows/getKnowledgeRetrievalStream',
  GET_PERSISTED_LIVE_CHAT_COMPONENTS:
    'workflows/getPersistedLiveChatComponents',
  GET_TRANSLATED_INTENT_CSAT_TEXT: 'workflows/getTranslatedIntentCsatText',
  HANDLE_CLICK_OUTSIDE_IFRAME: 'workflows/handleClickOutsideIframe',
  HANDLE_FREE_FORM_INPUT: 'workflows/handleFreeFormInput',
  HANDLE_SEND_MESSAGE: 'workflows/handleSendMessage',
  INIT_INTENT_CONVERSATION: 'workflows/initIntentConversation',
  MINIMIZE_WIDGET: 'workflows/minimizeWidget',
  RESET_INTENT_CONVERSATION: 'reset/conversation',
  RESTART_CONVERSATION: 'workflows/restartConversation',
  SEARCH_KNOWLEDGE: 'workflows/searchKnowledge',
  SEARCH_KNOWLEDGE_CLICK: 'workflows/searchKnowledgeClick',
  SELECT_WORKFLOW_TAG: 'workflows/getIntentsBySelectedTag',
  SEND_CONVERSATION_ALERT: 'workflows/sendConversationAlert',
  SEND_CONVERSATION_FEEDBACK: 'workflows/sendConversationFeedback',
  SEND_FREE_FORM_QUERY: 'workflows/sendFreeFormQuery',
  SET_CONVERSATION_ID: 'workflows/setConversationId',
  SET_FREE_FORM_QUERY: 'workflows/setFreeFormQuery',
  SET_INIT_CONVERSATION_INTENT: 'set/initConversationIntent',
  START_NEW_INTENT_SELECTION: 'start/newIntentSelection',
  SUBMIT_CSAT: 'workflows/submitCsat',
  SUBMIT_CSAT_V3: 'workflows/submitCsatV3',
  SUCCESSFUL_HANDOFF_ON_SUBMIT: 'workflows/successfulHandoffOnSubmit',
  TOGGLE_MODAL_VISIBILITY: 'workflows/toggleModalVisibility',
  UPDATE_HELPDESK_CONVERSATION: 'workflows/updateHelpdeskConversation',
  UPDATE_INTENT_CONVERSATION: 'workflows/updateIntentConversation',
} as const;
